import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { NoticeReceipentType, redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader
} from "../../../../../../../_metronic/_partials/controls";
import { ParentsFilter } from "./receipent-parents-filter/ParentsFilter";
import { ParentsTable } from "./receipent-parents-table/ParentsTable";
import { useParentsUIContext } from "./ParentsUIContext";

export function ParentsCard({
  receipentType
}) {
  // Parents Card UI Context
  const parentsUIContext = useParentsUIContext();
  const parentsUIProps = useMemo(() => {
    return {
      queryParams: parentsUIContext.queryParams
    };
  }, [parentsUIContext]);

  // Getting curret state of Parents from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type } = currentState;

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const parent = receipentType === NoticeReceipentType.Parent ? "Veli" : receipentType === NoticeReceipentType.Father ? "Baba" : receipentType === NoticeReceipentType.Mother ? "Anne" : "";

  return (
    <Card>
      <CardHeader title={"Gönderilen " + parent + " Listesi"} />
      <CardBody>
        <ParentsFilter />
        <ParentsTable
          receipentType={receipentType}
        />
      </CardBody>
    </Card>
  );
}